// extracted by mini-css-extract-plugin
module.exports = {"drop-aria":"DragAndDropAria_drop-aria__qSHaZ","browse":"DragAndDropAria_browse__FOa1s","drop-here":"DragAndDropAria_drop-here__kzw5D"};